import React, { useMemo } from "react";
import styled from "styled-components";

const hueFromString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return Math.abs(hash) % 360;
};

const Card = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: transform 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(139, 124, 255, 0.35);
  }
`;

const Top = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

const Badge = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Space Grotesk", sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.92);
  background: ${({ $from, $to }) => `linear-gradient(135deg, ${$from}, ${$to})`};
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const School = styled.div`
  font-size: 15.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.35;
`;

const Degree = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.secondary};
  font-weight: 500;
`;

const Date = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.text_muted};
`;

const Grade = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.text_secondary};

  b {
    color: ${({ theme }) => theme.text_primary};
    font-weight: 600;
  }
`;

const Description = styled.p`
  font-size: 13.5px;
  line-height: 1.65;
  color: ${({ theme }) => theme.text_secondary};
`;

const EducationCard = ({ education }) => {
  const hue = useMemo(() => hueFromString(education.school), [education.school]);
  const from = `hsl(${hue}, 65%, 46%)`;
  const to = `hsl(${(hue + 50) % 360}, 70%, 36%)`;
  const initials = education.school
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

  return (
    <Card>
      <Top>
        <Badge $from={from} $to={to}>
          {initials}
        </Badge>
        <Body>
          <School>{education.school}</School>
          <Degree>{education.degree}</Degree>
          <Date>{education.date}</Date>
        </Body>
      </Top>
      {education.grade && (
        <Grade>
          <b>Grade:</b> {education.grade}
        </Grade>
      )}
      <Description>{education.desc}</Description>
    </Card>
  );
};

export default EducationCard;
